import { getFunctions, httpsCallable } from "firebase/functions";

/**
 * Call an onCall Cloud Function and resolve to its `data` payload.
 *
 * The one way the panel invokes callables. Every function it calls is deployed
 * to us-central1, which is also the SDK default, so this is the same instance
 * that `getFunctions()`, `getFunctions(undefined, "us-central1")` and the
 * `functions` export in src/firebase.js all resolved to.
 *
 * `options` is passed straight to httpsCallable (e.g. `{ timeout: 60000 }`).
 * Errors are the SDK's FunctionsError, rethrown unchanged, so callers keep
 * reading `error.message` / `error.code` as before.
 */
export const callFunction = async (name, data, options) => {
  const functions = getFunctions();
  const callable = options
    ? httpsCallable(functions, name, options)
    : httpsCallable(functions, name);
  const result = await callable(data);
  return result.data;
};
